export enum Typography {
  /**
   * @deprecated Use Marketing titles or {@link Typography.DISPLAY_LARGE} instead.
   */
  DISPLAY_EXTRA_LARGE = 'display-extra-large',
  DISPLAY_LARGE = 'display-large',
  DISPLAY_MEDIUM = 'display-medium',
  DISPLAY_SMALL = 'display-small',
  DISPLAY_NUMBER = 'display-number',

  TITLE_SCREEN = 'title-screen',
  TITLE_SECTION = 'title-section',
  TITLE_SUBSECTION = 'title-subsection',
  TITLE_BODY = 'title-body',
  TITLE_GROUP = 'title-group',

  BODY_LARGE = 'body-large',
  BODY_DEFAULT = 'body-default',
  BODY_DEFAULT_BOLD = 'body-default-bold',
  BODY_LARGE_BOLD = 'body-large-bold',

  LINK_LARGE = 'link-large',
  LINK_DEFAULT = 'link-default',
}

/**
 * @deprecated Use {@link Typography.DISPLAY_LARGE} instead.
 */
export type DisplayExtraLarge = 'display-extra-large';
export type DisplayLarge = 'display-large';
export type DisplayMedium = 'display-medium';
export type DisplaySmall = 'display-small';
export type DisplayNumber = 'display-number';

export type DisplayTypes =
  | DisplayExtraLarge
  | DisplayLarge
  | DisplayMedium
  | DisplaySmall
  | DisplayNumber;

export type TitleScreen = 'title-screen';
export type TitleSection = 'title-section';
export type TitleSubsection = 'title-subsection';
export type TitleBody = 'title-body';
export type TitleGroup = 'title-group';

export type TitleTypes = TitleScreen | TitleSection | TitleSubsection | TitleBody | TitleGroup;

export type BodyDefault = 'body-default';
export type BodyLargeBold = 'body-large-bold';
export type BodyDefaultBold = 'body-default-bold';
export type BodyLarge = 'body-large';

export type BodyTypes = BodyLargeBold | BodyDefault | BodyLarge | BodyDefaultBold;

export type LinkDefault = 'link-default';
export type LinkLarge = 'link-large';

export type LinkTypes = LinkDefault | LinkLarge;

export type TypographyTypes =
  | TitleScreen
  | TitleSection
  | TitleSubsection
  | TitleBody
  | TitleGroup
  | BodyDefault
  | BodyLargeBold
  | BodyDefaultBold
  | BodyLarge
  | LinkDefault
  | LinkLarge;
